import React from 'react'
import styles from './styles.css'
import CoinCircle from 'App/components/CoinCircle'

const coins = ['BTC', 'ETH', 'LTC', 'XRP', 'CHA']

export default class Coins extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div className={styles.container}>
        {coins.map(coin => (
          <div key={coin} className={styles.coin}>
            <CoinCircle currencyCode={coin} />
          </div>
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Home/Layout/Footer/Coins/index.js